export enum ReportEventName {
  CoSyncRunResult = 'co_sync_run_result',
  CoSyncOperateResult = 'co_sync_operate_result',
  CoWorkerProcessInfo = 'co_worker_process_info',

  CoSyncCreateBegin = 'co_sync_create_begin',
  CoSyncCreateFinish = 'co_sync_create_finish',
  CoSyncConfigDialogShow = 'co_sync_config_dialog_show',
  CoSyncConfigDialogDone = 'co_sync_config_dialog_done',
  CoSyncStartBegin = 'co_sync_start_begin',
  CoSyncStartEnd = 'co_sync_start_end',
  CoSyncStopBegin = 'co_sync_stop_begin',
  CoSyncStopEnd = 'co_sync_stop_end',
  CoSyncDeleteBegin = 'co_sync_delete_begin',
  CoSyncDeleteEnd = 'co_sync_delete_end',
  CoSyncPageShowBegin = 'co_sync_page_show_begin',
  CoSyncPageShowEnd = 'co_sync_page_show_end',
  CoSyncPageClick = 'co_sync_page_click',
  CoSyncOperateDrawerShowBegin = 'co_sync_operate_drawer_show_begin',
  CoSyncOperateDrawerShowEnd = 'co_sync_operate_drawer_show_end',
  CoSyncOperateDrawerClose = 'co_sync_operate_drawer_close',
  CoSyncHistoryDrawerShowBegin = 'co_sync_history_drawer_show_begin',
  CoSyncHistoryDrawerShowEnd = 'co_sync_history_drawer_show_end',
  CoSyncHistoryDrawerClick = 'co_sync_history_drawer_click',
  CoSyncHistoryBeforeClear = 'co_sync_history_before_clear',
  CoSyncHistoryAfterClear = 'co_sync_history_after_clear',
  CoSyncProgress = 'co_sync_progress',

  CoSyncConflictDrawerShow = 'co_sync_conflict_drawer_show',
  CoSyncConflictDrawerClick = 'co_sync_conflict_drawer_click',
  CoSyncConflictNotificationShow = 'co_sync_conflict_notification_show',
  CoSyncConflictNotificationClick = 'co_sync_conflict_notification_click',
}

export interface CoSyncRunResultInfo {
  syncId: number;
  syncStrategy: string;
  result: string;
  error: string;
  runTime: number;
  taskCount: number; // 单次执行的指令数
  planTime: number;
  operateTime: number;
  scanTime: number;
}

export interface CoSyncOperateResult {
  syncId: number;
  type: string;
  result: string;
  error: string;
  runTime: number;
}

export interface CoWorkerProcessInfo {
  processName: string;
  crashReason: string;
  unResponsive: boolean;
}
